<template>
  <Modal
      v-model="_value"
      width="500"
      title="添加车辆分组"
      @on-visible-change="visibleChange"
      ok-text="添加"
      @on-ok="onOk">
    <Form ref="loginForm" :model="vehicleInfoGroup" >
      <FormItem prop="name">
        <Input v-model="vehicleInfoGroup.name" placeholder="请输入车辆分组名称">
        </Input>
      </FormItem>
      <FormItem prop="remark">
        <Input v-model="vehicleInfoGroup.remark" placeholder="备注">
        </Input>
      </FormItem>
      <FormItem prop="description">
        <Input v-model="vehicleInfoGroup.description" placeholder="请输入描述">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'addvehicleinfogroupmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      parentGroupId: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '车辆分组名不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data() {
      return {
        vehicleInfoGroup: {
          name:null,
          remark:null,
          description:null,
          parentGroupId:null,
          state:null
        }
      }
    },
    methods: {
      ...mapActions([
        'UserGroupServ_AddObj'
      ]),
      onOk() {
        this.$Modal.confirm({
          title: '添加车辆分组',
          content: '<p>是否确认添加车辆分组</p>',
          onOk: () => {
            store.dispatch('VehicleInfoGroupServ_AddObj', {params: this.vehicleInfoGroup}).then(() => {
              this.$Message.success('添加车辆分组成功')
              this.$emit('on-success');
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail');
            })
          },
          onCancel: () => {
          }
        })
      },
      visibleChange(val) {
        if(val){
          this.vehicleInfoGroup.name = null
          this.vehicleInfoGroup.remark = null
          this.vehicleInfoGroup.description = null
          this.vehicleInfoGroup.parentGroupId = this.parentGroupId
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _parentGroupId: {
        get() {
          return this.parentGroupId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
